export default __webpack_public_path__ + "static/media/signIn.ae280300.svg";